import { getUniqueOnboardingUrl, performOnboardingSetup // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase
} from './utils/redirectUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { mergeQueryParamsToUrl } from './utils/searchUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from './utils/urls';
import { getDecorationParams, maybeGetReplacementRedirectUrl } from './data/redirectData'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { maybeMapJobFieldToHubInterest } from './utils/surveyMappingUtils';
export const getOnboardingRedirectUrl = options => {
  const {
    hublet,
    apiUrl,
    appUrl
  } = options;
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(options.survey);
  return getUniqueOnboardingUrl(options);
};
export const setUpOnboardingConfig = options => {
  const {
    hublet,
    apiUrl,
    appUrl
  } = options;
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(options.survey);
  return performOnboardingSetup(options);
};
export function decorateRedirectUrl({
  url,
  portalId,
  signupType,
  survey = {},
  includeParams = {},
  queryParams = {},
  signupIntent,
  allowUrlReplacement = false,
  hublet,
  appUrl,
  apiUrl,
  shouldNotRedirectToSalesInstallationPage = false
}) {
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(survey);
  return mergeQueryParamsToUrl(allowUrlReplacement ? maybeGetReplacementRedirectUrl(url, {
    portalId,
    queryParams,
    signupIntent,
    signupType,
    shouldNotRedirectToSalesInstallationPage
  }) : url, Object.assign({}, includeParams, {}, getDecorationParams({
    intentLink: url,
    signupIntent,
    signupType,
    survey,
    queryParams
  })));
}